var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damageMobilierUptecFeature" }, [
    !_vm.isE2EFlow
      ? _c("div", { staticClass: "navbarCategories" }, [
          _c("img", {
            staticClass: "check-img",
            attrs: { src: require("@/assets/images/self-care/arrow-left.png") },
            on: { click: _vm.handleClickPrevPage },
          }),
          _c("p", { staticClass: "grayLightMouse headline-medium" }, [
            _vm._v(_vm._s(_vm.stateWarrantyDamagedPartKey)),
          ]),
        ])
      : _vm._e(),
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 2,
                textOfStep: _vm.$t("Déclaration des dommages"),
                handleClickBack: _vm.handleClickPrevPage,
                arrowIsAllow: true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "container-inputs" },
        [
          _c("p", { staticClass: "text-small-bold gray" }, [
            _vm._v(_vm._s(_vm.$t("damageMobilierUptecFeature.inputTxtValue"))),
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputTxtSearch,
                expression: "inputTxtSearch",
              },
            ],
            staticClass: "mg mg--t-1 mg--b-4 mg--l",
            attrs: { id: "search_text", type: "text" },
            domProps: { value: _vm.inputTxtSearch },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.inputTxtSearch = $event.target.value
                },
                _vm.handleChangeInputTxt,
              ],
              click: function ($event) {
                _vm.searchIsActive = true
              },
            },
          }),
          _c("svgicon", {
            staticClass: "seechIcon",
            attrs: {
              icon: "search-mobilier",
              height: "19",
              width: "19",
              color: "#7E8994",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "container-lists" }, [
        _vm.listItemsSearch.length > 0
          ? _c("ul", { staticClass: "category1-list" }, [
              _c(
                "p",
                { staticClass: "mg mg--l-4 mg--b-3 text-small-bold gray" },
                [_vm._v(_vm._s(_vm.$t("damageMobilier.search.categoryList")))]
              ),
              _c("li", [
                _c(
                  "div",
                  { staticClass: "container-results first-level" },
                  [
                    _c(
                      "p",
                      { staticClass: "searchText text-medium grayLightMouse" },
                      [
                        _vm._v(
                          _vm._s(_vm.listItemsSearch[0].product_group_name)
                        ),
                      ]
                    ),
                    _c("svgicon", {
                      attrs: {
                        icon: "arrow_right",
                        height: "17",
                        width: "10",
                        color: "#C5CACF",
                      },
                    }),
                  ],
                  1
                ),
                _c("ul", { staticClass: "category2-list" }, [
                  _c("li", [
                    _c(
                      "div",
                      { staticClass: "container-results second-level" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "searchText text-medium grayLightMouse mg mg--l-3",
                          },
                          [_vm._v(_vm._s(_vm.listItemsSearch[0].brand))]
                        ),
                        _c("svgicon", {
                          attrs: {
                            icon: "arrow_right",
                            height: "17",
                            width: "10",
                            color: "#C5CACF",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "ul",
                      { ref: "listItemsUptec", staticClass: "category3-list" },
                      [
                        _vm._l(_vm.listItemsSearch, function (item) {
                          return _c("li", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-results itemUptec mg mg--l-6",
                                on: {
                                  click: function ($event) {
                                    _vm.handleClickCategorySearch(
                                      item.product_id,
                                      item.image_small_url
                                    )
                                    _vm.handleClickCategExtraDetails(
                                      _vm.listItemsSearch[0].product_group_name,
                                      _vm.listItemsSearch[0].brand,
                                      item.name
                                    )
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: { src: item.image_small_url },
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "searchText text-medium grayLightMouse",
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _c("svgicon", {
                                  attrs: {
                                    icon: "arrow_right",
                                    height: "17",
                                    width: "10",
                                    color: "#C5CACF",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                        _vm.isloadingMoreItems
                          ? _c("li", [_c("maSpinner")], 1)
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm.searchNotFound === true
          ? _c("div", { staticClass: "container-empty_txt" }, [
              _c("p", { staticClass: "gray text-medium" }, [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt1"))
                ),
              ]),
              _c("p", { staticClass: "headline-medium mg mg--l-1 mg--r-1" }, [
                _vm._v('"' + _vm._s(_vm.inputTxtSearch) + '"'),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt2"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt3"))
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }